module.exports = __webpack_public_path__ + "media/images/metronic/datatables/back_enabled-8b15d1f32567eceb33751ae8858f92ce.png";